import { Skeleton } from '../design-system';

/**
 * Loading state for OddsPanel — same outer surface, header grid and
 * tier-row count (default 4) as the real panel.
 */
export function OddsPanelSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <section
      className="
        relative overflow-hidden rounded-[28px] border-2
        pt-[10px] px-[13px] pb-[17px]
        border-[rgba(171,174,179,0.24)]
        shadow-[0_64px_34px_0_rgba(0,0,0,0.05)]
        backdrop-blur-[27px]
        bg-[linear-gradient(180deg,rgba(255,255,255,0.2)_0%,rgba(153,153,153,0.2)_100%),linear-gradient(90deg,rgba(0,0,0,0.18)_0%,rgba(0,0,0,0.18)_100%)]
        text-white
      "
      aria-busy
      aria-label="Pack odds (loading)"
    >
      <header className="mb-4 grid grid-cols-3 items-start gap-2">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-[20px] w-[60px] rounded-[4px]" />
          <Skeleton className="h-[14px] w-[80px] rounded-[4px]" />
        </div>
        <div className="flex flex-col items-end gap-2">
          <Skeleton className="h-[14px] w-[90px] rounded-[4px]" />
          <Skeleton className="h-[20px] w-[70px] rounded-[4px]" />
        </div>
        <div className="flex flex-col items-end gap-2">
          <Skeleton className="h-[14px] w-[100px] rounded-[4px]" />
          <Skeleton className="h-[28px] w-[80px] rounded-[8px]" />
        </div>
      </header>

      <ul className="flex flex-col gap-[6px]">
        {Array.from({ length: rows }).map((_, i) => (
          <li key={i} className="grid grid-cols-3 items-center gap-2">
            <Skeleton className="h-[14px] w-[80px] rounded-[4px]" />
            <Skeleton className="ml-auto h-[14px] w-[70px] rounded-[4px]" />
            <Skeleton className="ml-auto h-[14px] w-[100px] rounded-[4px]" />
          </li>
        ))}
      </ul>
    </section>
  );
}
